export async function loadProposalHistoryModalShellComponent() {
  const module = await import('./proposal-history-modal-shell.component');
  return module.ProposalHistoryModalShellComponent;
}
